import React from "react";
import { useActiveWorkspaceRole } from "@hooks/permissions/useActiveWorkspaceRole";
import { Tag } from "@design-system/Tag/Tag";
import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { UserSchema } from "@common/schemas/user.schema";
import styles from "./UserDropdownHeader.module.scss";

interface UserDropdownHeaderProps {
    user: UserSchema;
}

export const UserDropdownHeader: React.FC<UserDropdownHeaderProps> = ({
    user,
}) => {
    const roleInWorkspace = useActiveWorkspaceRole();

    return (
        <div className={styles.userDropdownHeader}>
            <div
                className={styles.userDropdownUserName}
                data-testid="dropdown-user-name"
            >
                {user.name}
            </div>
            <div
                className={styles.userDropdownUserEmail}
                data-testid="dropdown-user-email"
            >
                {user.email}
            </div>

            {roleInWorkspace ? (
                <div className={styles.userDropdownUserRole}>
                    <Tag size="sm" color="neutral" outline>
                        {WORKSPACE_ROLES_LABELS[roleInWorkspace]}
                    </Tag>
                </div>
            ) : null}
        </div>
    );
};
